import React, { useEffect } from 'react';
import { Card, Checkbox } from 'semantic-ui-react';
import styles from './styles/Activity.module.scss';
import { useTranslation } from 'react-i18next';
import GridColumnInputWrapper from '@components/common/GridColumnInputWrapper';
import CommonTagsInputWrapper from '@components/common/CommonTagsInputWrapper';
import { connect } from 'react-redux';
import { locationsActions } from '@behavior/locations';
import { useFormContext } from 'react-hook-form';
import { ActivityDTO } from '@behavior/activity/dto/ActivityDTO';
import { VIEW_MODE } from '@src/constants';
import { ActivityLocationDTO } from '@behavior/activity/dto/ActivityLocationDTO';
import { LocationDTO } from '@behavior/inventories/dto/LocationDTO';

type Props = {
  locationList?: ActivityLocationDTO[];
  getLocationList?: () => void;
  selectedLocations: LocationDTO[];
  setSelectedLocations?: (selectedLocations: LocationDTO[]) => void;
  outOfBuilding: boolean;
  setOutOfBuilding?: (outOfBuilding: boolean) => void;
  activityData?: ActivityDTO;
  disabled?: boolean;
  mode?: string;
};

const ActivityLocation = ({
  getLocationList,
  locationList,
  selectedLocations,
  setSelectedLocations,
  outOfBuilding,
  setOutOfBuilding,
  disabled,
  mode,
}: Props) => {
  const { t } = useTranslation();
  const {
    register,
    clearErrors,
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    if (mode != VIEW_MODE && locationList && locationList.length === 0 && getLocationList) {
      getLocationList();
    }
  }, [mode]);

  useEffect(() => {
    setValue('location', selectedLocations);
  }, [selectedLocations]);

  const onLocationSelect = (selectedOptions: LocationDTO[]) => {
    if (setSelectedLocations) {
      setSelectedLocations(selectedOptions);
    }
    clearErrors('location');
  };

  const onOutOfBuilding = () => {
    if (setOutOfBuilding) {
      setOutOfBuilding(!outOfBuilding);
    }
  };

  return (
    <Card className={styles.locationCard}>
      <div className={styles.locationHeader}>
        {t('activity.details.page.location.container.title')}
      </div>
      <div className={styles.locationContainerContent}>
        <Checkbox
          label={
            <label className={styles.spanStyle}>
              {t('activity.details.page.location.container.is.out.of.building.input.label')}
            </label>
          }
          checked={outOfBuilding}
          type="checkbox"
          name={'outOfBuilding'}
          onClick={onOutOfBuilding}
          disabled={disabled}
        />
        <GridColumnInputWrapper
          {...register('location', {
            validate: {
              required: value =>
                (value && value.length > 0) || t('activity.form.error.location.required'),
            },
          })}
          name="location"
          label="activity.details.page.location.container.location.input"
          disabled={disabled}
          render={(props: any) => (
            <>
              <div className={styles.errorMessage}>{errors?.location?.message?.toString()}</div>
              <CommonTagsInputWrapper
                {...props}
                suggestionList={locationList}
                matchProperty="locationInfo"
                displayProps="locationInfo"
                value={selectedLocations}
                maxTags={2}
                onlyUnique
                onSelect={onLocationSelect}
              />
            </>
          )}
        />
      </div>
    </Card>
  );
};

const mapStateToProps = (state: any) => ({
  ...state.locations,
});

const mapDispatchToProps = (dispatch: any) => ({
  getLocationList: () => dispatch(locationsActions.getLocationAutocompleteList(false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivityLocation);
